import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

// 用于检测组件状态(打印日志信息)
import Logger from 'vuex/dist/logger'
// 控制plugins只在开发模式下生效
const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters,
  state,
  mutations,
  actions,
  modules: {
  },
  plugins: debug ? [Logger()] : []
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js